module.exports = __webpack_public_path__ + "img/add-user.96e3b540.svg";